const aboutData = {
  title: "About CSympl",
  text: "Save Time And Money Managing Your C-Store Remotely",
};

export default aboutData;
